// @todo - move to router global before guard
import { getInstance } from "./index";
import store from "@/store";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = async () => {
    try {
      // Request for an API token
      // Token will be cached (auth0 will handle that) so this won't request for a token everytime route changes
      const getToken = authService.getTokenSilently();

      // We will need to check if user session is stil active
      // We need to ignore cache because we need to get the updated session
      // We need the updated session so we can log out the user in this application in case the user logs out in another application
      // This will throw an error when user session is not active
      const checkSession = authService.auth0Client.getTokenSilently({
        ignoreCache: true,
      });

      store.commit("startLoading");

      const response = await Promise.all([getToken, checkSession]);

      // Store API token
      store.commit("auth/setToken", response[0]);

      // Get auth0 user data
      authService.user = await authService.auth0Client.getUser();
      // Store user
      // store.commit("auth/setUser", authService.user);

      // await Promise.all([
      //   store.dispatch("auth/fetchUser"),
      //   store.dispatch("config/fetchConfig"),
      // ]);
      await store.dispatch("auth/fetchUser");
      await store.dispatch("config/fetchConfig");

      store.commit("endLoading");

      return next();
    } catch (err) {
      // When user session is not active anymore, redirect to auth0 login
      // authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
      authService.logout({
        returnTo: `${process.env.VUE_APP_STORMPORT_UI_URL}/login`,
      });
    }
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  const unwatch = authService.$watch("loading", (loading) => {
    if (loading === false) {
      unwatch();
      return fn();
    }
  });
};
